import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import LoginPage from '../Login/LoginPage';

const PendingPage = () => {
  const navigate = useNavigate();
  const { logout, refreshUser, userData } = useAuth();
  const [checking, setChecking] = useState(false);
  const [toast, setToast] = useState('');

  const handleRefresh = async () => {
    setChecking(true);
    await Promise.all([
      refreshUser(),
      new Promise((r) => setTimeout(r, 1500)),
    ]);
    setChecking(false);
  };

  // refreshUser 후 userData가 변경되면 승인 상태 체크
  const prevChecking = React.useRef(false);
  React.useEffect(() => {
    // checking이 true→false로 바뀔 때만 (refresh 완료 시점)
    if (prevChecking.current && !checking && userData) {
      if (userData.status === 'approved') {
        navigate('/home', { replace: true });
      } else {
        setToast('아직 승인되지 않았습니다.');
        setTimeout(() => setToast(''), 2500);
      }
    }
    prevChecking.current = checking;
  }, [checking, userData, navigate]);

  return (
    <Wrapper>
      <LoginPage />
      <OverlayBg>
        {toast && <ToastBar>{toast}</ToastBar>}
        <OverlayContent>
          {checking ? (
            <SpinnerArea><OverlaySpinner /></SpinnerArea>
          ) : (
            <>
              <PendingText>승인 대기중</PendingText>
              <SubText>관리자 승인 후 이용 가능합니다.</SubText>
            </>
          )}
          <CheckBtn onClick={handleRefresh} disabled={checking}>
            {checking ? '확인 중...' : '승인 상태 확인'}
          </CheckBtn>
          <LogoutBtn onClick={() => { logout(); navigate('/login', { replace: true }); }}>로그인 화면으로 이동</LogoutBtn>
        </OverlayContent>
      </OverlayBg>
    </Wrapper>
  );
};

export default PendingPage;

const Wrapper = styled.div`
  position: relative;
  min-height: 100vh;
`;

const OverlayBg = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(26, 29, 41, 0.85);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 300;
  padding: 24px;
`;

const OverlayContent = styled.div`
  text-align: center;
  width: 100%;
  max-width: 320px;
`;

const PendingText = styled.p`
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
`;

const SubText = styled.p`
  font-size: 14px;
  color: #aaa;
  margin-bottom: 32px;
`;

const CheckBtn = styled.button`
  padding: 12px 36px;
  border-radius: 28px;
  background: #e8664a;
  color: white;
  font-size: 15px;
  &:disabled { opacity: 0.5; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const fadeSlide = keyframes`
  from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
`;

const SpinnerArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  margin-bottom: 8px;
`;

const OverlaySpinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid rgba(255,255,255,0.2);
  border-top-color: #e8664a;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const ToastBar = styled.div`
  position: fixed;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  z-index: 400;
  animation: ${fadeSlide} 0.3s ease;
  white-space: nowrap;
`;

const LogoutBtn = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  background: none;
  color: #aaa;
  font-size: 14px;
  text-decoration: underline;
`;
